import React from "react";
import { FiTrendingUp, FiTarget, FiCoffee, FiCalendar } from "react-icons/fi";
import MetricCard from "./MetricCard";
import { FoodLogStats } from "./types";

interface MetricsGridProps {
  stats: FoodLogStats;
}

export default function MetricsGrid({ stats }: MetricsGridProps) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        icon={
          <FiTrendingUp className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600 dark:text-purple-400" />
        }
        iconBgColor="bg-purple-100 dark:bg-purple-900/30"
        title="Total de Calorias"
        value={stats.total_calories.toLocaleString("pt-BR")}
        subtitle={`kcal nos últimos ${stats.days_analyzed} dias`}
      />

      <MetricCard
        icon={
          <FiTarget className="h-5 w-5 sm:h-6 sm:w-6 text-green-600 dark:text-green-400" />
        }
        iconBgColor="bg-green-100 dark:bg-green-900/30"
        title="Taxa de Aderência"
        value={`${stats.adherence_rate}%`}
        subtitle={`${stats.days_with_meals} dias com refeições`}
      />

      <MetricCard
        icon={
          <FiCoffee className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600 dark:text-blue-400" />
        }
        iconBgColor="bg-blue-100 dark:bg-blue-900/30"
        title="Média Diária de Calorias"
        value={stats.avg_daily_calories.toLocaleString("pt-BR")}
        subtitle="kcal por dia"
      />

      <MetricCard
        icon={
          <FiCalendar className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600 dark:text-purple-400" />
        }
        iconBgColor="bg-purple-100 dark:bg-purple-900/30"
        title="Total de Refeições"
        value={stats.total_meals}
        subtitle={`${stats.avg_daily_meals.toFixed(1)} por dia em média`}
      />
    </div>
  );
}
